/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// El hardware EduPlug tiene puertos fijos: servos SAT1/SAT2 y motores MD/MI, sin
// selector dinámico de pines.

Blockly.Blocks.EDUPLUG_joystick_link = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/eduplug_joystick.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.EDUPLUG_JOYSTICK_LINK_CONNECT, 'conectar'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_LINK_LINK, 'conectarNuevo'],
      ]), 'STAT');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.EDUPLUG_JOYSTICK_LINK);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.EDUPLUG_joystick_connected = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/eduplug_joystick.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.EDUPLUG_JOYSTICK_CONNECTED);
    // String 'Boolean' y no el constructor: en v13 el constructor no funciona como check.
    this.setOutput(true, 'Boolean');
  },
};

Blockly.Blocks.EDUPLUG_joystick_read = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/eduplug_joystick.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.EDUPLUG_JOYSTICK_LABEL)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_X_AXIX, 'X'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_Y_AXIX, 'Y'],
      ]), 'AXIS');
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_BLUE_TAG_WITHTAG)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_RIGHT_STICK, 'derecho'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_LEFT_STICK, 'izquierdo'],
      ]), 'STICK');
    this.setOutput(true);
  },
};

Blockly.Blocks.EDUPLUG_joystick_button_read = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/eduplug_joystick.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.EDUPLUG_JOYSTICK_LABEL)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTON_A, 'botonA'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTON_B, 'botonB'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTON_Y, 'botonY'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTON_X, 'botonX'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTTON_UP, 'flechaArriba'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTTON_DOWN, 'flechaAbajo'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTTON_LEFT, 'flechaIzquierda'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_BUTTTON_RIGHT, 'flechaDerecha'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_L1, 'botonL1'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_L2, 'valorL2'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_L3, 'botonL3'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_R1, 'botonR1'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_R2, 'valorR2'],
        [Blockly.Msg.EDUPLUG_JOYSTICK_READ_R3, 'botonR3'],
      ]), 'BUTTON');
    this.setOutput(true);
  },
};

Blockly.Blocks.EDUPLUG_motor_single = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/30.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar a la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar a la izquierda', '4'],
      ]), 'DIR');
    this.appendDummyInput('PIN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_SINGLE_PIN)
      .appendField(new Blockly.FieldDropdown([
        ['MD', 'Derecho'],
        ['MI', 'Izquierdo'],
      ]), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.EDUPLUG_motor_single_speed = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/30.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar a la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar a la izquierda', '4'],
      ]), 'DIR');
    this.appendDummyInput('PIN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_SINGLE_PIN)
      .appendField(new Blockly.FieldDropdown([
        ['MD', 'Derecho'],
        ['MI', 'Izquierdo'],
      ]), 'NPIN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.appendValueInput('PWM')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.EDUPLUG_motor_doble = Blockly.Blocks.BHOOT_motor_doble;

Blockly.Blocks.EDUPLUG_motor_doble_pwm = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_DOUBLE_FORWARD_SHORT || 'Avanzar', '3'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BACKWARD_SHORT || 'Retroceder', '4'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_RIGHT_SHORT || 'Girar a la derecha', '5'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_LEFT_SHORT || 'Girar a la izquierda', '6'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BRAKE_SHORT || 'Frenar', '7'],
      ]), 'DIR');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.appendValueInput('PWM')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_TOOLTIP);
  },
};

Blockly.Blocks.EDUPLUG_servo_move = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/eduplug_servo.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.EDUPLUG_SERVO_MOVE)
      .appendField(new Blockly.FieldDropdown([
        ['SAT1', 'Sat1'],
        ['SAT2', 'Sat2'],
      ]), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
  },
};
